<script>
    export let filled;
</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.724 10.199">
    {#if filled}
        <path d="M10.723 3.896l-3.7-.538L5.362 0 3.705 3.357l-3.7.538 2.676 2.614-.633 3.69 3.314-1.742 3.314 1.742-.633-3.69z"/>
    {:else}
        <path d="M10.723 3.896l-3.7-.538L5.362 0 3.705 3.357l-3.7.538 2.676 2.614-.633 3.69 3.314-1.742 3.314 1.742-.633-3.69zM5.362 7.628l-2.34 1.23.447-2.606-1.894-1.845 2.616-.38 1.17-2.371 1.168 2.371 2.616.38-1.89 1.846.447 2.606-2.34-1.23z"/>
    {/if}
</svg>

<style>
    svg {
        height: 0.5rem;
        margin-right: 0.125rem;
    }
</style>
